import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-file-names-modal',
  templateUrl: './file-names-modal.component.html',
  styleUrls: ['./file-names-modal.component.scss'],
  standalone: false
})
export class FileNamesModalComponent implements OnInit {

  readonly FILENAMES_CONTROL_NAME = 'fileNames';

  @Input()
  fileNames: string[] = [];

  @Input()
  existingFileNames: string[] = [];

  form: UntypedFormGroup;

  private fileNameSet: Set<string>;

  constructor(private fb: UntypedFormBuilder, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      [this.FILENAMES_CONTROL_NAME]: this.fb.array((this.fileNames || []).map(fileName => {
        return new UntypedFormControl(fileName, Validators.required)
      }), this.validateUniqueFilenames)
    });

    this.fileNameSet = new Set(this.existingFileNames || []);
  }

  get fileNameFormArray(): UntypedFormArray {
    return this.form.get(this.FILENAMES_CONTROL_NAME) as UntypedFormArray;
  }

  onSubmit(): void {
    this.activeModal.close(this.form?.value[this.FILENAMES_CONTROL_NAME] || [])
  }

  onCancel(): void {
    this.activeModal.dismiss('CANCELLED');
  }

  private validateUniqueFilenames: ValidatorFn = (control: AbstractControl) => {
    if (control) {
      const fileNameSet = new Set(this.fileNameSet);
      (<UntypedFormArray>control).controls.forEach(control => {
        if (!control.errors || !Object.keys(control.errors).length) {
          const value = control.value;
          if (value) {
            if (!value.trim()) {
              control.setErrors({filenameBlank: {messageKey: 'Please provide non-empty value'}});
            } else if (fileNameSet.has(value)) {
              control.setErrors({valueExists: {messageKey: 'File name already exists'}});
            } else {
              fileNameSet.add(value);
            }
          }
        }
      });
    }

    return null;
  }
}
